import React from 'react';
import { ApiTestSectionProps } from '../../../types';

const ApiTestSection: React.FC<ApiTestSectionProps> = ({ onTestApi, loading, response }) => {
  return (
    <div className="api-section">
      <h3>📡 API Status</h3>
      <button className="btn" onClick={onTestApi} disabled={loading}>
        {loading ? 'Calling...' : '🔌 Test API'}
      </button>
      
      {response && (
        <div className="api-response">
          <pre>{JSON.stringify(response, null, 2)}</pre>
        </div>
      )}
    </div>
  );
};

export default ApiTestSection;
